import { AbstractControl, FormGroup } from "@angular/forms";

export class ValidateUtils {


    /**
     * Valida si el Nif/Pasaporte es válido.
     * @param value valor del nif/pasaporte a validar.
     * @returns true si el nif/pasaporte es válido.
     * @return false si no es válido.
     */
    public static validateNifPassport(value:String) {
        var validChars = 'TRWAGMYFPDXBNJZSQVHLCKET';
        var nifRexp = /^[0-9]{8}[TRWAGMYFPDXBNJZSQVHLCKET]$/i;
        var nieRexp = /^[XYZ][0-9]{7}[TRWAGMYFPDXBNJZSQVHLCKET]$/i;
        var str = value.toString().toUpperCase();
        
        if (!nifRexp.test(str) && !nieRexp.test(str)) return false;
        
        var nie = str
            .replace(/^[X]/, '0')
            .replace(/^[Y]/, '1')
            .replace(/^[Z]/, '2');
        
        var letter = str.substr(-1);
        var charIndex = parseInt(nie.substr(0, 8)) % 23;
        
        if (validChars.charAt(charIndex) === letter) return true;
        
        return false;
          
    }

    /**
     * Valida si el Nif/Pasaporte es válido de un formulario.
     * @param control valor del nif/pasaporte a validar.
     * @returns null si el nif/pasaporte es válido.
     * @return {valid:false} si no es válido.
     */
    public static validateNifPassportForm(control: AbstractControl) {
        if (ValidateUtils.validateNifPassport(control.value)) {
            return null;
          }
      
          return { valid: false };
    }

    /**
     * Valida si hay un error genérico.
     * @form Formulario a validar.
     * @param value valor del código postal a validar.
     * @returns true si es válido.
     * @return false si no es válido.
     */
    public static validateErrorEmail(form: FormGroup, campo:string) {
        if (form.controls[campo].hasError("email")) {
            return true;
          }

        return false;
    }

    /**
     * Valida si se requiere un campo.
     * @param form formulario a validar.
     * @param value valor a validar.
     * @returns true si es válido.
     * @return false si no es válido.
     */
    public static validateErrorRequired(form: FormGroup, campo:string) {
        if (form.controls[campo].hasError("required")) {
        return true;
        }

        return false
    }
}